import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-center display-2 my-16 font-weight-bold"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProjectComponent = _resolveComponent("ProjectComponent")!

  return (_openBlock(), _createElementBlock("div", null, [
    true
      ? (_openBlock(), _createElementBlock("h1", _hoisted_1, " 🌍 Open source "))
      : _createCommentVNode("", true),
    _createVNode(_component_ProjectComponent, {
      class: "my-16",
      imgSrc: "/img/projects/shopify-syncer-connector-luceed-products-customers-inventory-orders-andromeda.webp",
      headerLink: {
        name: '🚀 Shopify Syncer - The Most Reliable Open-Source Shopify Connector',
        href: 'https://github.com/AndromedaTechnology/shopify-syncer-luceed',
      },
      tags: ['TypeScript', 'Koa.js', 'MongoDB', 'Mongoose', 'Jest', 'Docker'],
      descriptions: [
        `Manage your orders, products, inventory, customers.`,
        `Import Products and Inventory to Shopify from your system`,
        `Export Customers, Orders to your system`,
        `Now supporting: Luceed`,
      ],
      points: [
        'View, Create: Orders',
        'View, Create: Customers',
        'Sync Shopify Orders to Luceed',
        'Sync Luceed Products to Shopify',
        `Scalable architecture`,
        `Easy to extend`,
        `Bleeding-edge tools`,
      ],
      links: [
        {
          name: 'GitHub: API',
          href: 'https://github.com/AndromedaTechnology/shopify-syncer-luceed',
        },
        {
          name: 'Medium: Article',
          href: 'https://medium.com/andromeda-technology/the-most-reliable-open-source-shopify-connector-now-supporting-luceed-037776130f03',
        },
      ]
    }),
    _createVNode(_component_ProjectComponent, {
      class: "my-16",
      imgSrc: "/img/projects/distoro-os.png",
      headerLink: {
        name: '💻 Distoro OS - Operating System for x86 architecture',
        href: 'https://github.com/moltouni/distoro-os/',
      },
      tags: ['Open source Project', 'NASM', 'C'],
      descriptions: [
        `Uses FAT-12 filesystem, has working screen output, keyboard input,<br>
        exceptions, interrupts and allows for the usage of 4GB of RAM.`,
      ],
      links: [
        {
          name: 'GitHub: Repository',
          href: 'https://github.com/moltouni/distoro-os/',
        },
      ]
    }),
    _createVNode(_component_ProjectComponent, {
      imgSrc: "/img/projects/firestarter-api.png",
      class: "my-16",
      headerLink: {
        name: '🚀 FireStarter API - Progressive Startup API Boilerplate',
        href: 'https://github.com/AndromedaTechnology/firestarter-api',
      },
      tags: ['TypeScript', 'Koa.js', 'MongoDB', 'Mongoose', 'Jest', 'Docker'],
      descriptions: [
        `Easy to extend, Progressive and Scalable API boilerplate to power your startup.`,
      ],
      points: [
        `Scalable architecture`,
        `Easy to extend`,
        `Bleeding-edge tools`,
      ],
      links: [
        {
          name: 'GitHub: API',
          href: 'https://github.com/AndromedaTechnology/firestarter-api',
        },
      ]
    }),
    _createVNode(_component_ProjectComponent, {
      imgSrc: "/img/projects/ethereum-hardhat-observer.png",
      class: "my-16",
      headerLink: {
        name: '🔭 Ethereum Observer',
        href: 'https://github.com/AndromedaTechnology/ethereum-observer-api',
      },
      tags: [
        'Blockchain',
        'Ethereum',
        'Hardhat',
        'Solidity',
        'TypeScript',
        'Koa.js',
        'MongoDB',
        'Mongoose',
        'Jest',
        'Docker',
      ],
      descriptions: [
        `Simple block and transaction tracker for Ethereum network. `,
      ],
      points: [
        `Tracking block and transaction creation`,
        `Storing daily summary to Solidity smart contract`,
      ],
      links: [
        {
          name: 'GitHub: API',
          href: 'https://github.com/AndromedaTechnology/ethereum-observer-api',
        },
        {
          name: 'GitHub: Hardhat',
          href: 'https://github.com/AndromedaTechnology/ethereum-observer-contract-hardhat',
        },
      ]
    })
  ]))
}